import { Component, Input, Output, OnInit, forwardRef, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { bounceAnimation } from 'src/app/app.animation';

@Component({
  selector: 'app-check',
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss'],
  animations: [ bounceAnimation ],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckComponent),
    multi: true
  }]
})
export class CheckComponent implements OnInit, ControlValueAccessor {

  @Input() disabled:boolean = false;
  @Output() change = new EventEmitter();

  constructor() { }

  ngOnInit() {}

  private _value:boolean = false;
  @Input() set value(v:boolean) {  
    if(v !== this._value) {
      this._value = v;
      this.change.emit(v);
      this._onChangeCallback(v); 
    }
  }
  get value() { 
    return this._value; 
  }
  private _onChangeCallback = (v) => {};
  private _onTouchedCallback = (v) => {};
  writeValue(v:boolean): void { 
    if(v !== this._value) {
      this._value = v;
      this.change.emit(v);
      this._onChangeCallback(v);
    }
  }
  registerOnChange(fn: any): void {
    this._onChangeCallback = fn;
    console.info("app-check:registerOnChange");
  }
  registerOnTouched(fn: any): void {
    this._onTouchedCallback = fn;
    console.info("app-check:registerOnTouched");
  }
}

